export const LIST_LOCATION_REQUEST = 'LIST_LOCATION_REQUEST'
export const LIST_LOCATION_SUCCESS = 'LIST_LOCATION_SUCCESS'
export const LIST_LOCATION_FAIL = 'LIST_LOCATION_FAIL'

export const LIST_LOCATION_WITH_CLIENTID_REQUEST = 'LIST_LOCATION_WITH_CLIENTID_REQUEST'
export const LIST_LOCATION_WITH_CLIENTID_SUCCESS = 'LIST_LOCATION_WITH_CLIENTID_SUCCESS'
export const LIST_ADMISSION_LOCATION_WITH_CLIENTID_SUCCESS = 'LIST_ADMISSION_LOCATION_WITH_CLIENTID_SUCCESS'
export const LIST_LOCATION_WITH_CLIENTID_FAIL = 'LIST_LOCATION_WITH_CLIENTID_FAIL'

export const LIST_PROJECT_LOCATION_REQUEST = 'LIST_PROJECT_LOCATION_REQUEST'
export const LIST_PROJECT_LOCATION_SUCCESS = 'LIST_PROJECT_LOCATION_SUCCESS'
export const LIST_PROJECT_LOCATION_FAIL = 'LIST_PROJECT_LOCATION_FAIL'

export const RESET_LOCATION_WITH_CLIENTID = 'RESET_LOCATION_WITH_CLIENTID'

export const CREATE_LOCATION_REQUEST = 'CREATE_LOCATION_REQUEST'
export const CREATE_LOCATION_SUCCESS = 'CREATE_LOCATION_SUCCESS'
export const CREATE_LOCATION_FAIL = 'CREATE_LOCATION_FAIL'

export const UPDATE_LOCATION_REQUEST = 'UPDATE_LOCATION_REQUEST'
export const UPDATE_LOCATION_SUCCESS = 'UPDATE_LOCATION_SUCCESS'
export const UPDATE_LOCATION_FAIL = 'UPDATE_LOCATION_FAIL'

export const DELETE_LOCATION_REQUEST = 'DELETE_LOCATION_REQUEST'
export const DELETE_LOCATION_SUCCESS = 'DELETE_LOCATION_SUCCESS'
export const DELETE_LOCATION_FAIL = 'DELETE_LOCATION_FAIL'

export const DETAIL_LOCATION_REQUEST = 'DETAIL_LOCATION_REQUEST'
export const DETAIL_LOCATION_SUCCESS = 'DETAIL_LOCATION_SUCCESS'
export const DETAIL_LOCATION_FAIL = 'DETAIL_LOCATION_FAIL'

export const   SUMMARY_LOCATION_REQUEST = 'SUMMARY_LOCATION_REQUEST'
export const   SUMMARY_LOCATION_SUCCESS = 'SUMMARY_LOCATION_SUCCESS'
export const   SUMMARY_LOCATION_FAIL = 'SUMMARY_LOCATION_FAIL'  
